import styled, { css } from 'styled-components/macro'

export const Titulo = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.xlarge};
  `}
`
export const DivRight = styled.div`
  display: grid;
  justify-items: end;
  align-items: start;
`
